import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from "docz";
import MousePosition from "./use-mouse-position";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "use-mouse-position"
    }}>{`use-mouse-position`}</h1>
    <p>{`Hook Description`}</p>
    <Playground __position={0} __code={'<MousePosition />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      MousePosition
    }} mdxType="Playground">
  <MousePosition mdxType="MousePosition" />
    </Playground>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from "react";
import { useMousePosition } from "react-hooks-lab";

const MousePosition = () => {
  const { x, y } = useMousePosition();

  return (
    <div>
      Mouse position x: {x}
      <br />
      Mouse position y: {y}
    </div>
  );
};
export default MousePosition;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      